/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Auto-apply in-stock filter to search results
  if (window.location.pathname === '/search') {
    var params = new URLSearchParams(window.location.search);
    if (params.get('q') && !params.has('filter.v.availability')) {
      params.set('filter.v.availability', '1');
      window.location.replace(window.location.pathname + '?' + params.toString());
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && form.action.includes('/search')) {
      e.preventDefault();
      var params = new URLSearchParams(new FormData(form));
      params.set('filter.v.availability', '1');
      window.location.href = '/search?' + params.toString();
    }
  });

  // Auto-apply in-stock filter on all collection pages
  if (window.location.pathname.includes('/collections/')) {
    var params = new URLSearchParams(window.location.search);
    if (!params.has('filter.v.availability')) {
      params.set('filter.v.availability', '1');
      window.location.replace(window.location.pathname + '?' + params.toString());
    }
  }

  // Override add to cart button for pre-order variants (B2C)
  document.addEventListener('DOMContentLoaded', function() {
    function checkPreorder() {
      const productJSON = document.querySelector('[data-product-json]');
      if (!productJSON) return;
      
      const idInput = document.querySelector('input[name="id"]');
      if (!idInput) return;
      
      const product = JSON.parse(productJSON.innerHTML);
      const variantId = parseInt(idInput.value);
      const variant = product.variants.find(v => v.id === variantId);
      
      if (variant && variant.inventory_policy === 'continue' && variant.inventory_quantity <= 0) {
        document.body.setAttribute('data-preorder-soldout', 'true');
      } else {
        document.body.removeAttribute('data-preorder-soldout');
      }
    }

    checkPreorder();
    document.addEventListener('theme:variant:change', checkPreorder);
  });
  // Handle multi-variant preorder sold out state
  document.addEventListener('theme:variant:change', function(e) {
    const variant = e.detail.variant;
    if (!variant) return;
    
    const addToCartBtn = document.querySelector('[data-add-to-cart]');
    if (!addToCartBtn) return;
    
    if (window.preorderVariants && window.preorderVariants.includes(variant.id)) {
      addToCartBtn.setAttribute('data-preorder-soldout', '');
    } else {
      addToCartBtn.removeAttribute('data-preorder-soldout');
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();